/**
 * Created by lizheng on 2018/6/23.
 */
//定义dispatch的action名字，相当于redux中的reducer中的执行
export const INIT_CAMPAIGN = 'INIT_CAMPAIGN' //初始化活动
export const INIT_CAMPAIGN_STORE = 'INIT_CAMPAIGN_STORE'//初始化从local
export const INIT_CART_NUM = 'INIT_CART_NUM' //初始化购物车数量
export const INIT_MENU = 'INIT_MENU' //菜单数据
export const INIT_GOODS = 'INIT_GOODS'//
export const RELOAD_GOODS = 'RELOAD_GOODS'
export const CHANGE_BREAD = 'CHANGE_BREAD'//修改面包
export const RECORD_ADDRESS = 'RECORD_ADDRESS'
export const ADD_CART = 'ADD_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const LANGUAGE = 'LANGUAGE'
export const INIT_BUYCART = 'INIT_BUYCART'
export const CLEAR_CART = 'CLEAR_CART'
export const RECORD_SHOPDETAIL = 'RECORD_SHOPDETAIL'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const GET_USERINFO = 'GET_USERINFO'
export const SEARCH_KEYWORD = 'SEARCH_KEYWORD'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const TOGGLE_AGREEMENT = 'TOGGLE_AGREEMENT'
export const INIT_CAMPAIGN_LIST = 'INIT_CAMPAIGN_LIST'
export const INIT_AGREEMENT = 'INIT_AGREEMENT'
export const CLEAR_GOODS = 'CLEAR_GOODS'
export const SHOW_RULE = 'SHOW_RULE'
export const HIDE_RULE = 'HIDE_RULE'
export const SET_TEMPNAME = 'SET_TEMPNAME'
export const TOGGLE_AGREEMENT_LOADING = 'TOGGLE_AGREEMENT_LOADING'





// WEBPACK FOOTER //
// ./src/store/mutations-type.js